import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private translate: TranslateService) { }

  public init() {
    this.translate.setDefaultLang('default');
    this.translate.use(environment.clientID.toString());
  }
  
  public getString(key: string): string {
    return this.translate.instant(key);
  }
}
